import { useRef, useState } from 'react';
import ManorShell from './ManorShell';
import Draggable, { inside } from './Draggable';
import { PopupMessage, RulesButton, RulesModal, useStageSubmit } from './StageChrome';

const RULES = ['Drag and drop the potion to reveal the exit.', 'Make sure you have mixed the right quantity of potion.'];

// How many of each potion the pot needs (stage4.php).
const POTIONS = [
  { name: 'Amethyst Aura', img: 'Amethyst-Aura.png', need: 3 },
  { name: 'Azure Haze', img: 'Azure-Haze.png', need: 4 },
  { name: 'Earthly Delights', img: 'Earthly-Delights.png', need: 1 },
  { name: 'Magma Forge', img: 'Magma-Forge.png', need: 2 },
  { name: 'Polar Gust', img: 'Polar-Gust.png', need: 2 },
];
const TOTAL = POTIONS.reduce((n, p) => n + p.need, 0);

// Stage 4 (stage4.php): drag each potion into the pot the required number of times.
// Once all 12 are in, the message opens; closing it submits the stage (5 points).
export default function ManorStage4() {
  const submit = useStageSubmit(4);
  const pot = useRef(null);
  const [left, setLeft] = useState(POTIONS.map((p) => p.need));
  const [active, setActive] = useState(null);
  const [showRules, setShowRules] = useState(false);

  const poured = TOTAL - left.reduce((a, b) => a + b, 0);

  const drop = (i) => (pt) => {
    setActive(null);
    if (!pot.current || !inside(pot.current.getBoundingClientRect(), pt, 16)) return;
    setLeft((l) => l.map((n, k) => (k === i ? Math.max(0, n - 1) : n)));
  };

  return (
    <ManorShell bg="stage4/stage4_bg.png" bgMob="img/stage4/stage4_bg_mob.jpg" stage={4} className="manor-stage4">
      <div className="manor-toolbar">
        <RulesButton onClick={() => setShowRules(true)} />
      </div>

      <div className="manor-stage4-top">
        <img className="manor-stage4-title" src="/manor/img/stage4/Stage4_Title.png" alt="Stage 4" />
        <div className="manor-itemcount">
          {POTIONS.map((p, i) => (
            <div key={p.name} className={`manor-itembox${active === i ? ' active' : ''}`}>
              <h3>{p.name} -</h3>
              <span>{left[i]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="manor-scenebox">
      {POTIONS.map((p, i) =>
        left[i] > 0 ? (
          <Draggable key={p.name} className={`manor-potion manor-potion-${i}`} onStart={() => setActive(i)} onDrop={drop(i)}>
            <img src={`/manor/img/stage4/${p.img}`} alt={p.name} draggable={false} />
          </Draggable>
        ) : null
      )}
      </div>

      <div ref={pot} className="manor-pot">
        <img src="/manor/img/stage4/Pot.png" alt="Pot" draggable={false} />
      </div>

      {showRules && <RulesModal rules={RULES} onClose={() => setShowRules(false)} />}
      {poured === TOTAL && (
        <PopupMessage src="/manor/img/stage4/Stage4_popupmessage.png" alt="Stage 4 message" width="min(650px, 80vw)" onClose={() => submit(5)} />
      )}
    </ManorShell>
  );
}
